import { useTranslation } from "react-i18next";
import type { AgentSummary } from "@/api";
import { deleteAgentMutation, listAgentsQueryKey } from "@/api";
import { useDeleteEntity } from "@/components/build/useDeleteEntity";

/** Delete-with-confirm for an agent row/detail page. */
export function useDeleteAgent(onDeleted?: () => void) {
  const { t } = useTranslation("agents");
  return useDeleteEntity<AgentSummary>({
    mutation: deleteAgentMutation(),
    listQueryKey: listAgentsQueryKey,
    pathFor: (a) => ({ agent_uuid: a.uuid }),
    messages: { deleted: t("deleted"), deleteFailed: t("deleteFailed") },
    onDeleted,
  });
}
